import { useVoice } from "@/contexts/VoiceContext";
import { Volume2, Square, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

export function MessageSpeaker({ text, msgId, voiceOverride }) {
  const { speaking, speakingMsgId, speakText, stopSpeaking } = useVoice();
  const [loading, setLoading] = useState(false);
  const isThisSpeaking = speaking && speakingMsgId === msgId;

  const handleClick = async () => {
    if (isThisSpeaking) {
      stopSpeaking();
      return;
    }
    setLoading(true);
    await speakText(text, msgId, voiceOverride || null);
    setLoading(false);
  };

  return (
    <button
      data-testid={`speak-msg-${msgId}`}
      onClick={handleClick}
      className={cn(
        "bg-card border border-border/50 rounded-full px-2.5 py-1.5 flex items-center gap-1 text-xs shadow-sm transition-all",
        isThisSpeaking
          ? "text-primary border-primary/30 bg-primary/5"
          : "text-muted-foreground hover:text-primary hover:border-primary/30"
      )}
      title={isThisSpeaking ? "Stop playback" : "Listen to this message"}
    >
      {loading && !isThisSpeaking ? (
        <Loader2 className="w-3 h-3 animate-spin" />
      ) : isThisSpeaking ? (
        <Square className="w-3 h-3" fill="currentColor" />
      ) : (
        <Volume2 className="w-3 h-3" />
      )}
    </button>
  );
}
